
import { Component, Vue, Watch } from 'vue-property-decorator';
import stores from '@/stores';
import vPagination from '@/components/VuePlainPagination.vue';
import NevronHeader from '@/components/NevronHeader.vue';
import Skeleton from '@/modules/Skeleton.vue';
import NevronEmpty from '@/components/NevronEmpty.vue';
import NevronSearch from '@/components/NevronSearch.vue';
import NevronClickConfirm from '@/components/NevronClickConfirm.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import hexColorCode from '@/helpers/hexColorCode';
import getInitials from '@/helpers/initials';
import _ from 'lodash';
import PerPageDropdown from '../../../components/PerPageDropdown.vue';
import CreateDashboard from '@/modules/Dashboards/Create.vue';

@Component({
  components: {
    vPagination,
    NevronHeader,
    Skeleton,
    NevronEmpty,
    NevronSearch,
    NevronSearchNoResults,
    NevronClickConfirm,
    PerPageDropdown,
    CreateDashboard,
  },
})
export default class MobileIndex extends Vue {
  items: IDashboard[] = [];
  mobileModule = stores.mobileComposer;
  response: any = null;

  firstLoad = false;
  perpage = 20;

  indexList: number[] = [];
  defaultDashboardId = 0;
  dashboardType = 'Mobile';
  settingId: any = null;

  search: any = {
    query: '',
    current: '',
  };

  searchItems = _.debounce(() => {
    this.fetchData(1, this.search.query, this.perpage, this.dashboardType);
  }, 400);

  /*
   * Watch for pagination
   */
  @Watch('response.currentPage')
  changedPage() {
    if (this.firstLoad) {
      this.firstLoad = false;
      return;
    }
    this.search.query = this.search.current;
    this.fetchData(this.response.currentPage, this.search.current, this.perpage, this.dashboardType);
  }

  updateCheck(index: number) {
    this.indexList = [];
    this.indexList.push(index);
  }
  perPageChange() {
    this.fetchData(1, this.search.query, this.perpage, this.dashboardType);
  }
  /**
   * Called when changes need to re-render
   */
  mounted() {
    // set search query from URL
    if (this.$route.query.search) {
      this.search.query = this.$route.query.search;
      this.search.current = this.$route.query.search;
    }

    // set page from URL
    let index = 1;
    if (this.$route.query.page) {
      index = Number(this.$route.query.page);
    }
    // set perpage from URL
    if (this.$route.query.perpage) {
      this.perpage = Number(this.$route.query.perpage);
    }
    // load dashboard
    this.fetchDefaultDashboard();
    // load data
    this.fetchData(index, this.search.current, this.perpage, this.dashboardType);
  }

  refresh() {
    this.fetchData(this.response.currentPage, null, this.perpage, this.dashboardType);
  }

  openItem(itemId: string|number) {
    this.$router.push({name: 'mobileDashboards.show', params: {id: String(itemId)}, query: {lastpage: String(this.response.currentPage), perpage: String(this.perpage)}});
  }
  /**
   * Fetches data on the specified page and with the specified query
   */
  fetchData(
    index: number | null,
    search: string | null,
    perpage: number | 10,
    type: any | 'Mobile',
  ) {
    stores.dashboards
      .fetchData(index, search, perpage, type)
      .then((response) => {
        console.log(search);
        // wrong page
        if (response.currentPage < 0) {
          this.fetchData(1, search, perpage, type);
        } else if (response.currentPage > response.lastPage) {
          this.fetchData(response.lastPage, search, perpage, type);
        } else {
          this.response = response;
          this.items = this.response.data;

          this.search.current = this.search.query;
          this.fetchDefaultDashboard();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  /**
   * default dashboard id
   */
  fetchDefaultDashboard() {
    stores.Setting.getDashboard('default_dashboard_mobile').then((response) => {
      this.settingId = response.id;
      this.defaultDashboardId = response.value;
    });
  }

  /**
   * set default dashboard
   */
  updateDefaultDashboard(value: any) {
    stores.Setting.update(this.settingId, {value}).then((response) => {
      this.settingId = response.id;
      this.defaultDashboardId = response.value;
      this.refresh();
    });
  }
  /*
   * Get initials from admin's name
   */
  getInitials(str: string) {
    return getInitials(str);
  }

  /*
   * Get hex color code from string
   */
  hexColorCode(str: string) {
    return hexColorCode(str);
  }
}
